<template>
  <div>
    <div class="match-table">
      <div class="col-12">
        <h1>Mérkőzések</h1>
      </div>
      <div class="col-12">
        <table class="table big-table reverseOrder" v-if="allMatches.length>0">
          <tr v-for="(matchtype, mindex) in allMatches" :key="mindex" style="margin-top: 30px;">
            <div class="match-type-header">{{ niceMatchType(matchtype.type) }}</div>
            <table class="table table-striped">
              <thead>
              <tr>
                <th v-if="matchtype.type === 'csoport_merkozes'" class="type">Csoportkör</th>
                <th scope="col" class="date">Dátum és Időpont</th>
                <th scope="col" class="home">Hazai</th>
                <th scope="col" class="result">Eredmény</th>
                <th scope="col" class="guest">Vendég</th>
                <th scope="col" class="fogadas-th"> Fogadás</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="match in matchtype.matches" :key="match.id">
                <td v-if="matchtype.type === 'csoport_merkozes'" class="type">{{ match.group }}</td>
                <td class="date">{{ match.time }}</td>
                <td class="home">{{ match.home_team.country }}</td>
                <td class="result">{{
                    match.goals_home >= 0 ? match.goals_home : '-'
                  }}:{{ match.goals_guest >= 0 ? match.goals_guest : '-' }}
                <td class="guest">{{ match.guest_team.country }}</td>
                <td class="fogadas-td">
                  <div class="fogadas-cell" v-if="!isMatchTimePassed(match.time)">
                    <button @click="selectSelectedCountry(match); $bvModal.show('gabmle-modal')" class="btn btn-bet"
                            v-if="!myGamble(match)">Fogadok
                    </button>
                    <button @click="selectSelectedCountry(match); $bvModal.show('gabmle-modal')" class="btn btn-bet"
                            v-if="myGamble(match)">
                      Fogadás módosítása
                    </button>
                    <div class="margin-left--small font-weight-bold"
                         v-if="myGamble(match) && !isMatchTimePassed(match.time)">
                      {{ myGamble(match).goals_home }} : {{ myGamble(match).goals_guest }}
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex justify-content-center" v-if="myGamble(match)">
                      {{ myGamble(match).goals_home }} : {{ myGamble(match).goals_guest }}
                      <b-button class="margin-left--small btn btn-bet" v-b-toggle="match.id">Fogadások</b-button>
                    </div>
                    <div v-else>nem fogadtál</div>
                    <b-collapse :id="match.id" class="mt-2">
                      <b-card class="w-100">
                        <div v-for="gamble in match.gamble" :key="gamble.id" class="text-left card-text"><span
                            class="margin-right--small font-weight-bold">{{ gamble.user.name }}</span>{{ gamble.goals_home }}
                          : {{ gamble.goals_guest }}
                        </div>
                      </b-card>
                    </b-collapse>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            </tr>
            </table>
            
            </div>
            </div>
          

    <!-- MODAL - fogadás -->
    <b-modal
        :hide-footer="true"
        class="p-3"
        id="gabmle-modal"
        :title="selectedCountry && selectedCountry.gamble ? 'Fogadás módosítása': 'Fogadás'"
        @hidden="closedModal()"
    >
      <validation-observer v-slot="{ handleSubmit }" tag="div">
        <form @submit.prevent="handleSubmit(gamble)" v-if="!successGambleSubmit">
          <div class="modal-form-group">
            <ValidationProvider rules="required" v-slot="{ failedRules }" tag="div" class="country">
              <div class="form-label ">
                <strong> {{ selectedCountry.home_team.country }}</strong> <br/>
                <span class="type">Hazai csapat</span>
              </div>
              <input
                  v-model="forms.homeGoals"
                  type="text"
                  placeholder="-"
                  class="form-control"
                  name="homeTeam"
                  id="home"
                  ref="home"
                  v-mask="'####'"
              />
              <span class="error">{{
                  getErrorMessage("goal", Object.entries(failedRules)[0])
                }}
                    </span>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{ failedRules }" tag="div" class="country">
              <div class="form-label">
                <strong> {{ selectedCountry.guest_team.country }}</strong> <br/>
                <span class="type">Vendég csapat</span>
              </div>
              <input
                  class="form-control"
                  placeholder="-"
                  v-model="forms.guestGoals"
                  name="guest"
                  type="text"
                  v-mask="'####'"
              />
              <span class="error">{{
                  getErrorMessage("goal", Object.entries(failedRules)[0])
                }}</span>
            </ValidationProvider>
          </div>
          <div class="error error--server" v-if="gambleFormError">Hoppá..valami nem sikerült. Próbáld újra</div>
          <button type="submit"
                  class="btn btn-bet plus-margin-mob plus-padding-mob  margin-top--large m-auto--left m-auto--right">
            Fogadás beküldése
          </button>
        </form>
        <div v-else>
          <div class="success-form-submit">
            Köszönjük, fogadásod sikeresen elküldted.
          </div>
        </div>
      </validation-observer>
    </b-modal>
    
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import errorMessages from "@/assets/errorMessages.json";
// import ApiHandler from "@/mixins/apiHandlerMI"
import viewMI from "@/mixins/viewMI";
import {mask} from 'vue-the-mask'


export default {
  props: ['allMatches', 'gambles'],
  data() {
    return {
      forms: {
        guestGoals: null,
        homeGoals: null
      },
      myGambles: [],
      selectedCountry: null,
      successGambleSubmit: false,
      gambleFormError: false
    }
  },
  mixins: [viewMI],
  components: {
    ValidationProvider,
    ValidationObserver,

  },
  directives: {mask},
  methods: {
    userReady() {
      // console.log('matchtable userready', this.$store.state.user.id)
      // this.$store.dispatch("getMatches");      
      this.currentServerTime()     //start to get the current Server time              
    },
    getErrorMessage(fieldName, violation) {
      return violation
          ? (errorMessages[fieldName] &&
          errorMessages[fieldName][violation[0]]) ??
          violation[1]
          : undefined;
    },
    selectSelectedCountry(match) {
      let _this = this
      this.selectedCountry = match

      // if the match has gambles
      if (_this.selectedCountry.gamble) {
        _this.forms.homeGoals = _this.myGamble(_this.selectedCountry)?.goals_home ?? ''
        _this.forms.guestGoals = _this.myGamble(_this.selectedCountry)?.goals_guest ?? ''
      }
    },
    gamble() {
      let _this = this
      if (_this.myGamble(_this.selectedCountry)) {
        _this.editGamble()
      } else {
        _this.postGamble()
      }
    },
    postGamble() {
      // return () => {
      let _this = this;
      // ! le kell vizsgálni hogy a meccs ideje elmúlt e már küldés előtt
      // küldés előtt: a token aktív e még
      //szervert ha nem lehet elérni - hibaüzi?

      _this.post('gambling',
          {
            match_id: _this.selectedCountry.id,
            goals_home: _this.forms.homeGoals,
            goals_guest: _this.forms.guestGoals,
          },
          {}, function (response) {
            // console.log(response)
            if (response.data.status === true) {
              _this.successGambleSubmit = true
              location.reload();
            } else {
              _this.gambleFormError = true
            }
            // _this.userReady()
            this.$parent.getMatches()

          }, function (error) {
            //error ??
            console.log('error:', error)
            _this.gambleFormError = true

          }
      )
      // }
    },
    editGamble() {
      // return () => {
      let _this = this;

      _this.put('gambling',
          {
            gamble_id: _this.myGamble(_this.selectedCountry).id,
            goals_home: _this.forms.homeGoals,
            goals_guest: _this.forms.guestGoals,
          },
          {}, function (response) {
            if (response.data.status === true) {
              _this.successGambleSubmit = true
              location.reload();
            } else {
              _this.gambleFormError = true
            }
            // _this.userReady()
            this.$parent.getMatches()
            this.myGamble();
          }, function (error) {
            //error
            //console.log('login error:', error.data)

            //error ??
            console.log('error:', error)
            _this.gambleFormError = true
          }
      )
      // }
    },
    closedModal() {
      this.forms.homeGoals = null
      this.forms.guestGoals = null
      this.successGambleSubmit = false
      this.selectedCountry = null
      this.gambleFormError = false
    },
    isMatchTimePassed(time) {
      let _this = this
      // console.log('meccs idő',_this.currentTime, _this.moment(time).isBefore(_this.currentTime) )
      return _this.moment(time).isBefore(_this.currentTime)
    },
    niceMatchType(type) {
      let nicetype = ''
      if (type === 'csoport_merkozes') {
        nicetype = "Csoportmeccsek"
      } else if (type === 'tizenhatod_donto') {
        nicetype = "Legjobb 32"
      } else if (type === 'nyolcad_donto') {
        nicetype = "Nyolcad döntő"
      } else if (type === 'negyed_donto') {
        nicetype = 'Negyed döntő'
      } else if (type === 'donto') {
        nicetype = 'Döntő'
      }

      return nicetype
    },
    myGamble(match) {
      const _this = this;
      return match?.gamble?.find(g => g.user_id === _this.$store.state.user.id);
    }
  },

}
</script>

<style scoped>

</style>